import { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '../../components';
import './VideoPlayerDialog.css';

interface VideoPlayerDialogProps {
  url: string;
  onClose: () => void;
}

function VideoPlayerDialog({ url, onClose }: VideoPlayerDialogProps) {
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleOverlayClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === overlayRef.current) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return createPortal(
    <div
      ref={overlayRef}
      className="video-player-overlay"
      onClick={handleOverlayClick}>
      <div className="video-player-dialog">
        <button
          className="video-player-dialog__close"
          onClick={onClose}
          aria-label="Close video player">
          <Icon name="close" size={18} fill="currentColor" />
        </button>
        <video
          className="video-player-dialog__video"
          src={url}
          controls
          autoPlay
        />
      </div>
    </div>,
    document.body,
  );
}

export default VideoPlayerDialog;
